import React from 'react';
import { Grid, Typography } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import whoClasses from './whoStyles.js'


function WhoWeAreCulture() {
  const globalClasses = globalUseStyles();
  const whoStyles = whoClasses();
  return (
    <ThemeProvider theme={theme}>
        <Container className={globalClasses.standardContainer} maxWidth={false} component="section">
            <Grid className={globalClasses.containerSmall} container >
                <Grid className={globalClasses.containerInner} item xs={12} md={12}  >
                    <Typography  align="center" variant="subtitle1">Who We Are</Typography>
                    <Typography  align="center"  variant="h2">Our Culture </Typography>
                </Grid>
                <Grid item md={12} container spacing={3}>
                    <Grid  item xs={12} sm={6} md={6} lg={4} >
                    <div className={globalClasses.tealBox}>
                        <div className={globalClasses.cardInner}>
                            <Typography className={globalClasses.typSpacingBold}  variant="body1">Empathy</Typography>
                            <Typography   variant="body2">We believe all good products start with empathy – for the end users and for our clients. With that in mind, we design and develop through collaboration, there is no one size fits all model here. </Typography>
                        </div>
                    </div>
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} container>
                    <Grid item xs={12} md={12} className={whoStyles.cultureIcon1} />
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} container>
                    <Grid item xs={12} md={12} className={whoStyles.cultureImage1} />
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} container>
                    <Grid item xs={12} md={12} className={whoStyles.cultureImage2} />
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} >
                    <div className={globalClasses.tealBox}>
                        <div className={globalClasses.cardInner}>
                            <Typography className={globalClasses.typSpacingBold}  variant="body1">Transparency</Typography>
                            <Typography variant="body2">We let our clients see how the sausage is made. When we let you into our process, we create longer lasting relationships build on trust and communication.  </Typography>
                        </div>
                    </div>
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} >
                    <div className={globalClasses.tealBox}>
                        <div className={globalClasses.cardInner}>
                            <Typography  variant="h3">We have over 25 years of thoughtful leadership and experience.  </Typography>
                        </div>
                    </div>
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} >
                    <div className={globalClasses.tealBox}>
                        <div className={globalClasses.cardInner}>
                            <Typography className={globalClasses.typSpacingBold}  variant="body1">Continual Improvement</Typography>
                            <Typography  variant="body2">We employ an iterative approach to our products, processes, and ourselves to ensure that we are constantly moving in the right direction, one step at a time. </Typography>
                        </div>
                    </div>
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4} container>
                    <Grid item xs={12} md={12} className={whoStyles.cultureIcon2} />
                    </Grid>
                    <Grid  item xs={12} sm={6}  md={6} lg={4}>
                    <div className={globalClasses.tealBox}>
                        <div className={globalClasses.cardInner}>
                            <Typography className={globalClasses.typSpacingBold}  variant="body1">Collaboration</Typography>
                            <Typography  variant="body2">Success comes from a true partnership – and we love constant collaboration. From discovery to our sprint-based implementation process, we want your input each step of the way.  </Typography>
                        </div>
                    </div>
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    </ThemeProvider>
  );
};

export default WhoWeAreCulture;